export default "__VITE_ASSET__BNbb1M5O__"